var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar round-image",class:_vm.classObject,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.avatarUrl)?_c('img',{attrs:{"src":("/storage/" + _vm.avatarUrl)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }